import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Button,
  Typography,
  Flex,
  Grid,
  Radio,
  DatePicker,
  Checkbox,
  Upload,
  Modal,
  Tooltip,
  message,
  Switch,
} from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { InfoCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useWatch } from "antd/es/form/Form";
import {
  fetchCustomersCode,
  fetchEmployees,
  fetchLocations,
  fetchCustomersGroupList,
  createCustomer,
  fetchCustomersList,
} from "../customersThunks";
import Dropdown from "../../../components/DropDown/DropDown";
import { getCountryList } from "../../../libs/currency";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./customer.css";
import { createCustomerPayload } from "../../../utils/customers";
import { saveCustomerGroup, saveCustomers } from "../../../services/customer";
import { fetchSingleInstitutionDetails } from "../../../store/commonThunks/lookups";
import { getAccessType } from "../../../lib/functions";
import dayjs from "dayjs";
import { fetchDeliveryRoutes } from "../../Delivery/deliveryThunks";
import { selectDeliveryRoutes } from "../../Delivery/deliverySelectors";
import { getISOFromCountryName, gstTypeOptions, indianStates } from "../../../lib/currency";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import {
  createOrUpdateLocation,
  fetchLocationsList,
} from "../../Locations/locationsThunks";
import LocationFormBody from "../../Locations/components/LocationFormBody";
const { Option } = Select;

const { Title } = Typography;
const { useBreakpoint } = Grid;

const customersType = [
  {
    label: "Retailer",
    value: "retailer",
  },
  {
    label: "Wholesaler",
    value: "wholesaler",
  },
  {
    label: "Distributor",
    value: "distributor",
  },
  {
    label: "Corporate",
    value: "corporate",
  },
];

const CreateCustomerForm = ({
  authInfo,
  isDrawer = false,
  onSuccess,
  form: externalForm,
}) => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const location = useLocation();
  const navigate = useNavigate();
  const [internalForm] = useForm();
  const form = externalForm || internalForm;

  const isStacked = isDrawer || !screens.lg;

  const params = new URLSearchParams(location.search);
  const returnTo = params.get("returnUrl");

  const selectedGstType = useWatch("gst_type", form);
  const selectedCountry = useWatch("country", form);
  const customerType = useWatch("party_type", form);
  const creditTime = useWatch("credit_day", form);
  const isAlsoCreditor = useWatch("is_also_creditor", form);
  const creditLabelByTime = creditTime === "days" ? "Days" : "Months";

  // ── Drug Store in UAE flag only ──
  const isUAE = authInfo?.country === "United Arab Emirates";
  const isDrugStoreUAE =
    authInfo?.company_type === "Drug Store" && isUAE;

  // ── Customer type options ──
  const customersType = isDrugStoreUAE
    ? [
      { label: "Class A", value: "wholesaler" },
      { label: "Class B", value: "corporate" },
      { label: "Class C", value: "distributor" },
    ]
    : [
      { label: "Retailer", value: "retailer" },
      { label: "Wholesaler", value: "wholesaler" },
      { label: "Distributor", value: "distributor" },
      { label: "Corporate", value: "corporate" },
    ];
  const isFieldHidden = (fieldKey, pageKey = "customer_entry") => {
    return authInfo?.visibilitytabs?.some(
      (item) => item.page_key === pageKey && item.field_key === fieldKey,
    );
  };

  const {
    isEditCustomer,
    selectedCustomer,
    customerCode,
    employees,
    locations,
    customersGroupList,
  } = useSelector((state) => state.customers);
  const { institutionData } = useSelector((s) => s.lookups);
  const deliveryRoutes = useSelector(selectDeliveryRoutes);
  let [access_type, access_type_set] = useState("");
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [customerGroupModalOpen, setCustomerGroupModalOpen] = useState(false);
  const [customerGroupForm] = Form.useForm();
  const [locationForm] = Form.useForm();
  const companyType = authInfo.company_type;

  useEffect(() => {
    const access = getAccessType("customer_entry");
    access_type_set(access);
  }, []);

  useEffect(() => {
    if (
      selectedGstType === "regular" ||
      selectedGstType === "composition"
    ) {
      form.setFieldsValue({ country: "India" });
    }
  }, [selectedGstType]);

  // ── Force default party_type for Drug Store / Pharmacy ──
  useEffect(() => {
    if (!isEditCustomer) {
      form.setFieldsValue({
        party_type: isDrugStoreUAE ? "wholesaler" : "retailer",
      });
    }
  }, [isDrugStoreUAE, isEditCustomer]);

  const { user } = useSelector((state) => state.auth);
  const countries = getCountryList();

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSave = async (values) => {
    let country_code = authInfo?.country_code;
    const payload = createCustomerPayload(
      values,
      country_code,
      employees,
      locations,
      user,
      isEditCustomer ? selectedCustomer?.acc_id : null,
    );

    try {
      const res = await dispatch(createCustomer(payload)).unwrap();
      if (res && !res.error) {
        modal.success({
          title: res?.msg || "Customer Created",
          content: "",
        });

        const newCode = values.acc_code;
        const list = await dispatch(fetchCustomersList()).unwrap();
        const created = list?.find((c) => c.acc_code === newCode);
        const params = created
          ? { state: { newCustomerId: created.acc_id } }
          : undefined;

        if (isDrawer) {
          onSuccess?.(created);
        } else {
          navigate(returnTo || "/customers", params);
        }
      }
    } catch (error) {
      modal.warning({
        title: error?.message,
        content: "",
      });
      console.log(error);
    }
  };

  const safeDate = (date) => {
    if (!date) return null;
    const d = dayjs(date);
    return d.isValid() ? d : null;
  };

  useEffect(() => {
    if (isEditCustomer && selectedCustomer) {
      const existingFile =
        selectedCustomer.document_url &&
          typeof selectedCustomer.document_url === "string"
          ? selectedCustomer.document_url.split(",").map((url, idx) => ({
            uid: `existing-${idx}`,
            name: url.split("/").pop(),
            status: "done",
            url,
          }))
          : [];

      const normalizedCreditDay =
        selectedCustomer.credit_day === "days" ||
          selectedCustomer.credit_day === "day"
          ? "days"
          : "month";

      form.setFieldsValue({
        ...selectedCustomer,
        state: selectedCustomer.province || "",
        document_url: existingFile,
        credit_day: normalizedCreditDay,
        institution_owner: selectedCustomer?.institution_owner
          ? selectedCustomer.institution_owner.split(",").map((v) => v.trim())
          : [],
        licence_validity: safeDate(selectedCustomer.licence_validity),
        gln_validity: safeDate(selectedCustomer.gln_validity),
      });
    }
  }, [isEditCustomer, selectedCustomer, form]);

  useEffect(() => {
    if (!isEditCustomer) {
      dispatch(fetchCustomersCode());
    }
    dispatch(fetchSingleInstitutionDetails());
    dispatch(fetchLocations());
    dispatch(fetchEmployees());
    dispatch(fetchCustomersGroupList());
    dispatch(fetchDeliveryRoutes({}));
  }, [dispatch]);

  useEffect(() => {
    if (!isEditCustomer && customerCode) {
      form.setFieldsValue({ acc_code: customerCode });
    }
  }, [customerCode, form]);

  const defaultCountry = getISOFromCountryName(authInfo?.country);
  const isIndia = authInfo?.country?.toLowerCase() === "india";
  const gstEnabled = authInfo?.gst_enabled === "yes";
  const isIndiaGst = isIndia && gstEnabled;
  const isIndianCustomer = selectedCountry?.toLowerCase() === "india";
  const isGstRequired =
    isIndiaGst &&
    (selectedGstType === "regular" || selectedGstType === "composition");
  return (
    <div className="invoice-form">
      {!isDrawer && (
        <Title
          level={2}
          style={{
            marginBottom: "32px",
          }}
        >
          {isEditCustomer ? "Update Customer" : "Create new customer"}
        </Title>
      )}
      <Form
        form={form}
        layout={isDrawer ? "vertical" : "horizontal"}
        onFinish={handleSave}
        initialValues={{
          party_type: "retailer",
          opening_balance: 0
        }}
        variant="filled"
        style={{ maxWidth: isDrawer ? "100%" : "1400px" }}
        className={`responsive-form ${isDrawer ? "drawer-form" : ""}`}
        colon={false}
        // labelCol={{
        //   span: 8,
        // }}
        // wrapperCol={{
        //   span: 16,
        // }}
        labelCol={{
          xs: { span: 24 },
          sm: { span: 8 },
          md: { span: 8 },
          lg: { span: 6 },
          xl: { span: 7 },
          xxl: { span: 6 },
        }}
        wrapperCol={{
          xs: { span: 24 },
          sm: { span: 16 },
          md: { span: 16 },
          lg: { span: 18 },
          xl: { span: 14 },
          xxl: { span: 16 },
        }}
      >


        {/* <Flex
          style={{
            width: !screens.md || !screens.xl ? "100%" : "61%",
            marginBottom: "32px",
            paddingLeft: screens.xl ? "5.5rem" : "0px",
            justifyContent: "flex-start",
          }}
        > */}
        {/* <Form.Item
            label="Customer Type*"
            name="party_type"
            labelCol={{ span: 6 }}    
            wrapperCol={{ span: 18 }}
            style={{              
              marginBottom: 32,
            }}
            data-testid="customer-type-radio"
          >
            <Radio.Group options={customersType} />
          </Form.Item> */}
        {/* </Flex> */}
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            // flexDirection: !screens.md || !screens.xl ? "column" : "row",
            flexDirection: isStacked ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{
              width: isStacked ? "100%" : "40%",
            }}
          >
            <Form.Item
              label="Customer Type*"
              name="party_type"
              // labelCol={{ span: 6 }}
              // wrapperCol={{ span: 18 }}
              // style={{
              //   marginBottom: 32,
              // }}
              className="customer-form"
              data-testid="customer-type-radio"
            >
              <Radio.Group options={customersType} />
            </Form.Item>
            <Form.Item
              label="Code"
              name="acc_code"
              className="customer-form"
              rules={[{ required: true, message: "Customer Code is Required" }]}
            >
              <InputField
                disabled
                value={form.getFieldValue("acc_code") || customerCode || ""}
              />
            </Form.Item>
            <Form.Item
              label="Customer name"
              name="acc_name"
              className="customer-form"
              rules={[{ required: true, message: "Customer Name is Required" }]}
            >
              <InputField
                placeholder="Customer name"
                data-testid="customer-name-input"
              />
            </Form.Item>
            <Form.Item
              label="Customer Group"
              name="customer_group_id"
              className="customer-form"
            >
              <Dropdown
                placeholder="Select a group"
                options={customersGroupList?.map((el) => ({
                  label: el.name,
                  value: el.id,
                }))}
                dropdownRender={(menu) => (
                  <>
                    <div
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={() => setCustomerGroupModalOpen(true)}
                    >
                      + Add New
                    </div>
                    {menu}
                  </>
                )}
              />
            </Form.Item> {console.log(institutionData)}

            <Form.Item
              label={
                institutionData?.country === "United Arab Emirates" &&
                  (authInfo?.company_type === "Pharmacy" || institutionData?.subscription_type_name.toLowerCase().includes("pharma") ||
                    institutionData?.subscription_type_name.toLowerCase().includes("PharmaBooks"))
                  ? "Rep."
                  : "Account Manager Name"
              }
              name="acc_mgr"
              className="customer-form"
            >
              <InputField
                data-testid="institution-name-input"
                placeholder={
                  institutionData?.country === "United Arab Emirates" &&
                    (authInfo?.company_type === "Pharmacy" || institutionData?.subscription_type_name.toLowerCase().includes("pharma") ||
                      institutionData?.subscription_type_name.toLowerCase().includes("PharmaBooks"))
                    ? "Medical Representative"
                    : "Account Manager Name"
                }
              />
            </Form.Item>
            {(companyType === "Drug Store" ||
              companyType === "Pharmacy") && (
                <Form.Item
                  label="Employee"
                  name="employee_id"
                  className="customer-form"
                >
                  <Select
                    placeholder="Select Employee"
                    showSearch
                    optionFilterProp="children"
                  >
                    {employees?.map((e) => (
                      <Option key={e.employee_id} value={e.employee_id}>
                        {e.employee_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            <Form.Item
              label="Institution Name"
              name="institution_name"
              className="customer-form"
            >
              <InputField placeholder="Institution name" />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  Institution Owner Name&nbsp;
                  <Tooltip title="Type multiple owner names (Max 5) separated by commas">
                    <InfoCircleOutlined style={{ color: "#8c8c8c" }} />
                  </Tooltip>
                </span>
              }
              name="institution_owner"
              className="customer-form "
              rules={[
                {
                  validator: (_, value) =>
                    value && value.length > 5
                      ? Promise.reject("Maximum 5 owners only allowed")
                      : Promise.resolve(),
                },
              ]}
            >
              <Select
                className="tag-multiselect"
                maxTagCount="responsive"
                mode="tags"
                suffixIcon={null}
                tokenSeparators={[","]}
                placeholder="Enter owner names"
                onChange={(values) => {
                  if (values.length > 5) {
                    // auto-remove last entered value
                    message.error('Only five owner names allowed.');
                    values.pop();
                  }
                  form.setFieldsValue({ institution_owner: values });
                }}
              />
            </Form.Item>



            <Form.Item label="Address" name="address" className="customer-form">
              <InputField placeholder="Address" data-testid="address-input" />
            </Form.Item>
            <Form.Item
              label="Email Address"
              name="email_address"
              className="customer-form"
              rules={[
                { required: false },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
              ]}
            >
              <InputField placeholder="Email" data-testid="email-input" />
            </Form.Item>
            {(customerType === "wholesaler" ||
              customerType === "distributor" ||
              customerType === "corporate" ||
              (customerType === "retailer" &&
                companyType === "Drug Store")) && (
                <>
                  <Form.Item
                    label="Status"
                    name="cus_status"
                    className="customer-form"
                  >
                    <Dropdown
                      defaultValue={"active"}
                      options={[
                        {
                          value: "active",
                          label: "Active",
                        },
                        {
                          value: "inactive",
                          label: "Inactive",
                        },
                      ]}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Mode Of Payment"
                    name="mode_of_payment"
                    className="customer-form"
                  >
                    <InputField placeholder="Mode of payment" />
                  </Form.Item>
                </>
              )}
            <Form.Item
              label="Licence No"
              name="licence_no"
              className="customer-form"
            >
              <InputField placeholder="Licence no" />
            </Form.Item>

            <Form.Item
              label="Licence Validity"
              name="licence_validity"
              className="customer-form"
            >
              <DatePicker
                placeholder="Select date"
                style={{
                  width: "100%",
                  height: "39.6px",
                }}
                disabledDate={(current) => {
                  // Block today and previous dates
                  return current && current < dayjs().add(1, "day").startOf("day");
                }}
              />
            </Form.Item>
            <Form.Item
              name="is_also_creditor"
              valuePropName="checked"
              className="customer-form"
              label="Also a Supplier"
            >
              <Switch checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
            {isAlsoCreditor && !selectedCustomer?.linked_acc_id && (
              <Form.Item
                name="supplier_opening_balance"
                label="Opening Due (as Supplier)"
                className="customer-form"
                tooltip="Amount you owed this party as a supplier before starting to use this software"
              >
                <InputField placeholder="0" type="number" />
              </Form.Item>
            )}
            {/* </>
            )} */}
          </Flex>
          <Flex
            vertical
            gap={10}
            style={{
              width: isStacked ? "100%" : "40%",
            }}
          >
            <Form.Item
              label="Opening Due"
              name="opening_balance"
              className="customer-form"
              rules={[
                {
                  pattern: /^\d*\.?\d*$/,
                  message: "Only numbers are allowed",
                },
              ]}
            >
              <InputField
                onFocus={(e) => {
                  if (e.target.value === "0") {
                    form.setFieldsValue({ opening_balance: "" });
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              label="Contact No"
              name="contact_no"
              className="customer-form"
              rules={[
                { required: false },
                {
                  pattern: /^[0-9]{7,15}$/,
                  message: "Enter valid contact number",
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();

                    const phoneNumber = parsePhoneNumberFromString(`+${value}`);

                    if (!phoneNumber || !phoneNumber.isValid()) {
                      return Promise.reject("Invalid phone number");
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <PhoneInput
                country={defaultCountry}
                inputStyle={{
                  width: "100%",
                  height: "35.19px",
                  background: "rgba(0,0,0,0.04)",
                  borderColor: "transparent",
                }}
                placeholder="Contact no"
              />
            </Form.Item>
            <Form.Item
              label="Country"
              name="country"
              className="customer-form"
              data-testid="country-select"
            >
              <Dropdown options={countries} placeholder="Select country" />
            </Form.Item>

            {isIndiaGst && isIndianCustomer && (
              <Form.Item
                name="state"
                label="State"
                className="customer-form"
                rules={[{ required: true, message: "State is required" }]}
              >
                <Select placeholder="Select State" showSearch>
                  {indianStates.map((state) => (
                    <Option key={state.code} value={state.name}>
                      {state.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>)}

            <Form.Item label="Po Box" name="po_box" className="customer-form">
              <InputField placeholder="Po box" />
            </Form.Item>

            <Form.Item label="Shipping Address" name="shipping_address" className="customer-form">
              <InputField placeholder="Shipping Address" data-testid="shipping-address-input" />
            </Form.Item>

            <Form.Item
              label="Shipping Contact No"
              name="shipping_contact_no"
              className="customer-form"
              rules={[
                {
                  pattern: /^[0-9]{7,15}$/,
                  message: "Enter valid contact number",
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();

                    const phoneNumber = parsePhoneNumberFromString(`+${value}`);

                    if (!phoneNumber || !phoneNumber.isValid()) {
                      return Promise.reject("Invalid phone number");
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <PhoneInput
                country={defaultCountry}
                inputStyle={{
                  width: "100%",
                  height: "35.19px",
                  background: "rgba(0,0,0,0.04)",
                  borderColor: "transparent",
                }}
                placeholder="Shipping contact no"
              />
            </Form.Item>

            <Form.Item
              label="Shipping Po Box"
              name="shipping_po_box"
              className="customer-form"
            >
              <InputField placeholder="Shipping Po box" />
            </Form.Item>
            <Form.Item
              label="Shipping Contact Person"
              name="shipping_contact_person"
              className="customer-form"
            >
              <InputField placeholder="Shipping contact person" />
            </Form.Item>

            {isIndiaGst && (
              <Form.Item
                label="GST Type"
                name="gst_type"
                rules={[
                  { required: true, message: "GST Type is required" }
                ]}
                className="customer-form"
                data-testid="gst-type-select"
              >
                <Dropdown
                  options={gstTypeOptions}
                  placeholder="Select GST Type"
                  allowClear
                />
              </Form.Item>
            )}

            {(!isIndia || gstEnabled) && (
              <Form.Item
                label={isIndia ? "GST No." : "VAT No."}
                name="vat_no"
                rules={
                  isGstRequired
                    ? [
                      { required: true, message: "GST Number is required" },
                      {
                        pattern:
                          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                        message: "Enter valid GSTIN",
                      },
                    ]
                    : []
                }
                extra={isIndia ? "Format: 22AAAAA0000A1Z5" : undefined}
                className="customer-form"
              >
                <InputField placeholder={
                  isIndia
                    ? "Enter GST Number"
                    : "Enter VAT Number"
                } />
              </Form.Item>
            )}
            <Form.Item
              label="Location/Area"
              name="location_id"
              className="customer-form"
            >
              <Select
                placeholder="Select a Location/Area"
                options={locations?.map((el) => ({
                  label: el.location_name,
                  value: el.location_id,
                }))}
                dropdownRender={(menu) => (
                  <>
                    <div
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={() => setLocationModalOpen(true)}
                      data-testid="add-new-location-option"
                    >
                      + Add New
                    </div>
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            {(companyType === "Drug Store" || companyType === "Pharmacy") && (
              <>
                <Form.Item
                  label="GLN Number"
                  name="gln_no"
                  className="customer-form"
                >
                  <InputField placeholder="GLN number" />
                </Form.Item>

                <Form.Item
                  label="Company Prefix Length"
                  name="company_prefix_length"
                  className="customer-form"
                  rules={[
                    {
                      pattern: /^\d+$/,
                      message: "Company Prefix Length must be a number",
                    },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();

                        const length = Number(value);

                        if (length < 6 || length > 12) {
                          return Promise.reject(
                            "Company Prefix Length must be between 6 and 12"
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputField
                    type="number"
                    placeholder="Enter Company Prefix Length"
                    min={6}
                    max={12}
                  />
                </Form.Item>  

                <Form.Item label="GLN Validity" className="customer-form">
                  <DatePicker
                    placeholder="Select date"
                    style={{
                      width: "100%",
                      height: "39.6px",
                    }}
                  />
                </Form.Item>

                <Form.Item label="Class Type" className="customer-form">
                  <InputField placeholder="Class type" />
                </Form.Item>
              </>
            )}
            <Form.Item
              label="Credit Limit"
              name="credit_limit"
              className="customer-form"
            >
              <InputField
                placeholder="Credit limit"
                data-testid="credit-limit-input"
              />
            </Form.Item>
            <Form.Item
              label="Credit Time"
              name="credit_day"
              className="customer-form"
              style={{
                width: "100%",
              }}
            >
              <Radio.Group
                data-testid="credit-time-radio"
                options={[
                  {
                    label: "Month",
                    value: "month",
                  },
                  {
                    label: "Days",
                    value: "days",
                  },
                ]}
              />
            </Form.Item>
            <Form.Item
              label={`Credit ${creditLabelByTime}`}
              name="credit_month"
              className="customer-form"
            >
              <InputField
                placeholder={`Enter ${creditLabelByTime}`}
                data-testid="credit-duration-input"
              />
            </Form.Item>
            {!isFieldHidden("Upload Doc") && (
              <Form.Item
                label="Upload Document"
                name="document_url"
                className="customer-upload-document"
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) return e;
                  return e?.fileList || [];
                }}
                rules={[
                  {
                    validator: (_, value) =>
                      value && value.length > 5
                        ? Promise.reject("Maximum 5 documents allowed")
                        : Promise.resolve(),
                  },
                ]}
              >
                <Upload
                  beforeUpload={() => false}
                  multiple
                  maxCount={5}
                >
                  <Button block icon={<UploadOutlined />}>
                    Upload Documents (Max 5)
                  </Button>
                </Upload>
              </Form.Item>

            )}
            {deliveryRoutes && deliveryRoutes.length > 0 && (
              <Form.Item
                label="Default Delivery Route"
                name="default_delivery_route_id"
                className="customer-form"
              >
                <Select
                  allowClear
                  placeholder="Select delivery route"
                  options={deliveryRoutes.map((r) => ({ label: r.name, value: r.id }))}
                />
              </Form.Item>
            )}
            {/* {!isEditCustomer && (
              <Form.Item name="enable_login" valuePropName="checked">
                <Checkbox>Enable Login</Checkbox>
              </Form.Item>
            )}  */}
          </Flex>
        </Flex>
        <Form.Item
          style={{
            marginTop: "24px",
          }}
        >
          <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
            {!isDrawer && (
              <Button
                size="large"
                shape="default"
                onClick={handleCancel}
                className="traic-button"
              >
                Back
              </Button>
            )}
            {!isDrawer && access_type == "WRITE" && (
              <>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className="traic-button"
                  data-testid="save-customer-button"
                >
                  {isEditCustomer ? "Update" : "Save"}
                </Button>
              </>
            )}
          </Flex>
        </Form.Item>
      </Form>

      <Modal
        open={locationModalOpen}
        title="Add New Location"
        onCancel={() => {
          locationForm.resetFields();
          setLocationModalOpen(false);
        }}
        onOk={async () => {
          try {
            const values = await locationForm.validateFields();

            const res = await dispatch(
              createOrUpdateLocation({
                ...values,
                action: "create",
                location_id: 0,
              }),
            ).unwrap();

            // 🔥 refresh customer locations (THIS IS THE KEY)
            const updatedLocations = await dispatch(fetchLocations()).unwrap();

            // 🔥 find newly created location
            const created = updatedLocations?.find(
              (l) => l.location_name === values.location_name,
            );

            if (created) {
              form.setFieldsValue({ location_id: created.location_id });
            }

            locationForm.resetFields();
            setLocationModalOpen(false);
          } catch (err) {
            // validation or API error handled by AntD
          }
        }}
        okText="Save Location"
        hiddenOnClose
      >
        <Form form={locationForm} layout="vertical">
          <LocationFormBody />
        </Form>
      </Modal>

      <Modal
        open={customerGroupModalOpen}
        title="Add New Customer Group"
        onCancel={() => {
          customerGroupForm.resetFields();
          setCustomerGroupModalOpen(false);
        }}
        onOk={async () => {
          try {
            const values = await customerGroupForm.validateFields();

            // 🔥 SAME PAYLOAD AS CustomersGroupList
            const payload = {
              action: "create",
              id: 0,
              name: values.name,
            };

            await saveCustomerGroup(payload);

            // 🔥 Refresh redux list
            const updatedGroups = await dispatch(
              fetchCustomersGroupList(),
            ).unwrap();

            // 🔥 Auto-select newly created group
            const created = updatedGroups?.find((g) => g.name === values.name);

            if (created) {
              form.setFieldsValue({
                customer_group_id: created.id,
              });
            }

            customerGroupForm.resetFields();
            setCustomerGroupModalOpen(false);
          } catch (err) {
            // handled by AntD / API
          }
        }}
        okText="Save Group"
        destroyOnHidden
      >
        <Form form={customerGroupForm} layout="vertical">
          <Form.Item
            label="Customer Group Name"
            name="name"
            rules={[
              { required: true, message: "Customer Group name is required" },
            ]}
          >
            <InputField placeholder="Enter customer group name" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default CreateCustomerForm;
